import { Component } from '@angular/core';
import { DialogRequest, LbConfirmService, PromptOptions } from './lb-confirm.service';

/** Renders LbConfirmService requests. Placed once, in the app root. */
@Component({
  selector: 'lb-confirm-host',
  template: `
    <lb-modal *ngIf="service.current$ | async as request" [title]="request.options.title" size="sm" [centered]="true"
              [closeOnBackdrop]="!request.isPrompt" (closed)="cancel()">
      <form id="lb-confirm-form" (ngSubmit)="ok(request)">
        <p class="mb-0" *ngIf="request.options.message" [class.mb-3]="request.isPrompt">{{ request.options.message }}</p>
        <ng-container *ngIf="request.isPrompt">
          <label class="form-label" for="lb-prompt-input">{{ asPrompt(request).label }}</label>
          <textarea *ngIf="asPrompt(request).multiline; else single" id="lb-prompt-input" class="form-control" rows="3" name="value"
                    [(ngModel)]="value" [placeholder]="asPrompt(request).placeholder || ''" autofocus></textarea>
          <ng-template #single>
            <input id="lb-prompt-input" type="text" class="form-control" name="value" [(ngModel)]="value"
                   [placeholder]="asPrompt(request).placeholder || ''" autocomplete="off" autofocus>
          </ng-template>
        </ng-container>
      </form>
      <div lbModalFooter>
        <button type="button" class="btn btn-secondary" (click)="cancel()">{{ request.options.cancelText || 'Cancel' }}</button>
        <button type="submit" form="lb-confirm-form" class="btn" [ngClass]="request.options.danger ? 'btn-danger' : 'btn-primary'"
                [disabled]="request.isPrompt && asPrompt(request).required && !value.trim()" [attr.autofocus]="request.isPrompt ? null : ''">
          {{ request.options.confirmText || 'OK' }}
        </button>
      </div>
    </lb-modal>
  `
})
export class LbConfirmHostComponent {
  value = '';

  constructor(public service: LbConfirmService) {
    service.current$.subscribe(request => {
      this.value = request && request.isPrompt ? (this.asPrompt(request).initialValue || '') : '';
      // The confirm button sits in the footer, outside the body the modal scans for [autofocus]
      if (request && !request.isPrompt) setTimeout(() => (document.querySelector('lb-confirm-host .modal-footer button[autofocus]') as HTMLElement | null)?.focus(), 30);
    });
  }

  asPrompt(request: DialogRequest): PromptOptions {
    return request.options as PromptOptions;
  }

  ok(request: DialogRequest): void {
    if (request.isPrompt) {
      if (this.asPrompt(request).required && !this.value.trim()) return;
      this.service.answer(this.value.trim());
    } else {
      this.service.answer(true);
    }
  }

  cancel(): void {
    const request = this.service.current$.value;
    this.service.answer(request && request.isPrompt ? null : false);
  }
}
